import React from 'react';
import { useRouter } from 'next/router';
import statisticPages from '../../lib/statisticPagesConfig';
import Layout from '../Layout';
import Hero from '../Hero';
import throw404 from '../../lib/throw404';

interface StatisticPageLayoutProperties {
  children: React.ReactNode;
}

const StatisticPageLayout = ({ children }: StatisticPageLayoutProperties) => {
  const { query } = useRouter();
  const slug = String(query.slug);

  if (!(slug in statisticPages)) return throw404();
  const pageData = statisticPages[slug];

  const { title, headerImageUrls } = pageData;

  return (
    <Layout header={(
      <Hero
        alt={title}
        imageUrls={headerImageUrls}
      />
      )}
    >
      {children}
    </Layout>
  );
};

export default StatisticPageLayout;
